































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import ModalAdd from './ModalAdd.vue'
import { trainingMaterialDataModule } from '@/app/store/modules/trainingMaterial'

@Component({
  components: {
    search: Search,
    'modal-add': ModalAdd,
    'modal-delete-all': ModalDeleteAll,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public clearRowSelected
  @Prop({}) public id
  @Prop({}) public imageDataCategory

  public resetText() {
    //  console.log('reset text')
  }

  // Property Button Delete All
  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    trainingMaterialDataModule.deleteTrainingMaterial({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
}
